import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import CURadioButton from '@/components/CURadioButton.vue'
import RecommendedBanner from '@/components/RecommendedBanner.vue'
import VehicleOptionDescription from '@/components/VehicleOptionDescription.vue'
import VehicleOptionImage from '@/components/VehicleOptionImage.vue'
import VehicleOptionVehicleList from '@/components/VehicleOptionVehicleList.vue'

import { roundedCurrencyFilter } from '../utils/string'
import { SalesBotVehicleOption } from "@/models/dto/SalesbotV2VehicleOptions"


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotVehicleOptionCard',
  props: {
    vehicleOption: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as { vehicleOption: SalesBotVehicleOption };




const selected = computed(() => props.vehicleOption?.selected)
const showRecommendedBanner = computed(() => props.vehicleOption?.recommended)
const vehicles = computed(() => props.vehicleOption.vehicles)
const vehicleTypeKeys = computed(() => vehicles.value.map(({ vehicleTypeKey }) => vehicleTypeKey))
const passengerCapacity = computed(() => props.vehicleOption.maxPassengerCapacity)

const totalAmount = computed(() => props.vehicleOption.amount)
const totalDollars = computed(() => Math.floor(totalAmount.value))
const totalDollarsFormatted = computed(() => totalDollars.value ? roundedCurrencyFilter(totalDollars.value) : '')
const totalCents = computed(() => {
  const cents = totalAmount.value - totalDollars.value
  return cents.toFixed(2).split('.')[1]
})

const select = () => emit('select')

return { __sfc: true,props, emit, selected, showRecommendedBanner, vehicles, vehicleTypeKeys, passengerCapacity, totalAmount, totalDollars, totalDollarsFormatted, totalCents, select, CURadioButton, RecommendedBanner, VehicleOptionDescription, VehicleOptionImage, VehicleOptionVehicleList }
}

})